module.exports = __webpack_public_path__ + "static/media/19ESCAP38.b73e5ec4.jpg";